import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import BoundImageModal from '../../components/boundImageModal';
import {pxToEm} from '../../components/globalStyles';
import WrapperAppUl from '../../components/wrapperAppUl';
import WorldwideCustomersPng from '../../media/aboutUsPageView/worldwide_customers.png';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > div:first-child {
    flex: 7;
    margin-right: ${pxToEm(100)}em;
  }

  > div:last-child {
    flex: 4;
  }
`;

const StyledLeadingVendorH2 = styled.h2`
  font-size: ${pxToEm(24)}em;
  font-weight: bold;
  color: ${baseVariables.colors.midnight};
`;

const StyledA = styled.a`
  text-decoration: none;
  color: ${baseVariables.colors.bitmovinBlue};
`;

const StyledWrapperAppUl = styled(WrapperAppUl)`
  margin-top: ${pxToEm(20)}em;
  margin-bottom: ${pxToEm(30)}em;
`;

const StyledImageModal = styled(BoundImageModal)`
  width: 100%;
`;

const StyledImg = styled.img`
  width: 100%;
`;

//#endregion

const WorldwideCustomersSection: React.FunctionComponent = () => {
  const worldwideCustomers = <StyledImg src={WorldwideCustomersPng} alt="worldwide customers" />;

  return (
    <StyledWrapperDiv>
      <div>
        <StyledImageModal boundComponent={worldwideCustomers} source={WorldwideCustomersPng} />
      </div>
      <div>
        <StyledLeadingVendorH2>The category leader in video infrastructure</StyledLeadingVendorH2>

        <StyledWrapperAppUl>
          <li>
            Continuous R&D focus and deep academic collaboration with 10 PhD’s in Bitmovin’s research lab -
            <StyledA href="https://athena.itec.aau.at/publications/" target="_blank">
              &nbsp;ATHENA
            </StyledA>
          </li>
          <li>Actively contributing to standardization (MPEG, W3C, AOM)</li>
          <li>Enabling developers to get to value - quickly and easily</li>
        </StyledWrapperAppUl>
      </div>
    </StyledWrapperDiv>
  );
};

export default WorldwideCustomersSection;
